// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://oljveinssanyowgskncp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9sanZlaW5zc2FueW93Z3NrbmNwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQzNTE0NzIsImV4cCI6MjA4OTkyNzQ3Mn0.waDpfxbIU9ZxFKQk2RPawWUOSige3oUcNG5KXBUlXqw";

console.warn("DIAGNOSTIC: Supabase Client initialized with HARD-CODED values.");

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'chawni-auth-token-v3', // Bump key just in case an old lock is still held
    
    // Custom lock function to bypass navigator.locks deadlock entirely.
    // This resolves the known @supabase/gotrue-js issue where Vite HMR
    // fails to release locks correctly, causing signInReq to hang indefinitely.
    lock: async (name, acquireTimeout, fn) => {
      return await fn();
    },
  },
  global: {
    headers: { 'x-client-info': 'chawni-debug' },
  },
});